import { Dropdown, CheckBoxSelection, InputField } from "../../components";
import Icons from "../../assets/icon";
import Functions from "./index.function";
const PhysicalAttributes = ({
  register,
  errors,
  control,
  select,
  setSelect,
  setValue,
}) => {
  const { dropdowns, handleDropdwonSelect, isLoading, RadioValueandLable } =
    Functions(setSelect);
  return (
    <div className={"flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto"}>
      <div className="w-full">
        <Dropdown
          control={control}
          rightIcon={Icons.arrowIcon}
          label={"Hair Types"}
          options={dropdowns?.hairTypes}
          name={"hairTypes"}
          isMandatory={true}
          selectedValue={select.hairTypes}
          valueName="name"
          valueoption="hair_type_id"
          handleSelect={(value) => handleDropdwonSelect("hairTypes", value)}
          errors={errors}
          isLoading={isLoading}
        />
      </div>
      <div className="w-full">
        <InputField
          control={control}
          label="Height"
          sublabel={"(cm)"}
          type="number"
          name="height"
          maxLength={6}
          isMandatory={true}
          // {...register("height", {
          //     required: "Height is required",
          //     validate: {
          //         validFormat: (value) => {
          //             const match = value.match(/^(\d{2,3})\s?cm$/i);
          //             if (!match) return "Height must be in cm (e.g., 170 cm)";
          //             const numericHeight = parseInt(match[1], 10);
          //             if (numericHeight < 120 || numericHeight > 220) {
          //                 return "Height must be between 120 cm and 220 cm";
          //             }
          //             return true;
          //         },
          //     },
          //     maxLength: {
          //         value: 6,
          //         message: "Height cannot exceed 6 characters",
          //     },
          // })}
          {...register("height", {
            required: "Height is required",
            valueAsNumber: true,
            min: {
              value: 120,
              message: "Height must be at least 120 cm",
            },
            max: {
              value: 220,
              message: "Height cannot exceed 220 cm",
            },
            maxLength: {
              value: 6,
              message: "Height cannot exceed 6 characters",
            },
          })}
          onChange={(value) => setValue("height", value)}
          errors={errors}
        />
      </div>
      <div className="w-full">
        <InputField
          control={control}
          label="Weight"
          sublabel={"(kg)"}
          type="number"
          name="weight"
          maxLength={6}
          isMandatory={true}
          // {...register("weight", {
          //     required: "Weight is required",
          //     validate: {
          //         validFormat: (value) => {
          //             const match = value.match(/^(\d{2,3})\s?kg$/i);
          //             const numericWeight = parseInt(match[1], 10);
          //             if (numericWeight < 25 || numericWeight > 200) {
          //                 return "Weight must be between 25 kg and 200 kg";
          //             }
          //             return true;
          //         },
          //     },
          //     maxLength: {
          //         value: 6,
          //         message: "Weight cannot exceed 6 characters",
          //     },
          // })}
          {...register("weight", {
            required: "Weight is required",
            valueAsNumber: true,
            min: {
              value: 25,
              message: "Weight must be at least 25 kg",
            },
            max: {
              value: 200,
              message: "Weight cannot exceed 200 kg",
            },
            maxLength: {
              value: 6,
              message: "Weight cannot exceed 6 characters",
            },
          })}
          onChange={(value) => setValue("weight", value)}
          errors={errors}
        />
      </div>
      <div className="w-full">
        <Dropdown
          control={control}
          rightIcon={Icons.arrowIcon}
          label={"Eye Colors"}
          options={dropdowns?.eyeColors}
          name={"eyeColors"}
          isMandatory={true}
          selectedValue={select.eyeColors}
          valueName="name"
          valueoption="eye_color_id"
          handleSelect={(value) => handleDropdwonSelect("eyeColors", value)}
          errors={errors}
          isLoading={isLoading}
        />
      </div>
      <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-2">
        <CheckBoxSelection
          control={control}
          name="bodyTattoos"
          mapitems={RadioValueandLable}
          register={register}
          isMandatory={true}
          errors={errors}
          label="Body Modifications / Tattoos"
        />
      </div>
      <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-1">
        <CheckBoxSelection
          control={control}
          name="bodyPiercings"
          mapitems={RadioValueandLable}
          isMandatory={true}
          register={register}
          errors={errors}
          label="Body Modifications / Piercings"
        />
      </div>
    </div>
  );
};

export default PhysicalAttributes;
